import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { FormattedMessage } from 'react-intl'
import arrow from '../../assets/imgs/buttons/right-arrow.svg'
import SckeletonBlog from '../skeleton/SckeletonBlog'
import BlogService from '../../services/blog.service'
import CardNews from './CardNews'
import './news-box.scss'
import AppContainer from '../../component/layout/AppContainer.tsx'

const NewsBox = () => {
  const [posts, setPosts] = useState([])
  const [loading, setLoading] = useState(true)

  const getPostsBlog = async () => {
    const response = await BlogService.getPostsBlog()
    const only3Posts = _.slice(response, 0, 3)
    setPosts(only3Posts)
    setLoading(false)
  }
  useEffect(() => {
    getPostsBlog()
  }, [])

  return (
    <AppContainer className="news-wrapper">
      <div className="boxWrapper-header">
        <h2 className="title__container">
          <FormattedMessage id="news" />
        </h2>
        <a
          className="text__with-color link"
          href="https://grupomoure.com/blog/"
          target="_blank"
          rel="noreferrer"
        >
          <FormattedMessage id="link.got.news" />
          <img className="linkImg" src={arrow} alt="arrow" />
        </a>
      </div>
      <div className="newsBox">
        {loading ? (
          <>
            <SckeletonBlog />
            <SckeletonBlog />
            <SckeletonBlog />
          </>
        ) : (
          posts.map((post) => <CardNews key={post?.title} post={post} />)
        )}
      </div>
    </AppContainer>
  )
}
export default NewsBox
